import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import UnstyledButton from '../Buttons/UnstyledButton';
import env from '../../env';

const SUPPORT_TEAM_EMAIL = env.support_team_email;
const MAIL_TO = 'mailto:' + SUPPORT_TEAM_EMAIL;

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const TextBlock = styled.div`
  margin-top: 20px;
  padding: 10px;
  background-color: #f5f5f5;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
`;

const StyledButton = styled(UnstyledButton)`
  color: blue;
`;

const ErrorMessage: React.FC = () => {
  const { t } = useTranslation();

  const handleClick = () => {
    window.location.reload();
  };

  return (
    <>
      <Container>
        <TextBlock>
          <p>
            {t('errorMessage.somethingWentWrong')}
            <StyledButton onClick={handleClick}>
              {t('errorMessage.clickHere')}
            </StyledButton>
            {t('errorMessage.toTryAgain')}
          </p>
          <p>
            {t('errorMessage.persists')}
            <a href={MAIL_TO}>{SUPPORT_TEAM_EMAIL}</a>.
          </p>
        </TextBlock>
      </Container>
    </>
  );
};

export default ErrorMessage;
